import { cloneDeep } from "lodash";
import type { StaticWorkerPoolResource } from "~/client/resources";
import type { WorkerPoolEditState } from "./WorkerPoolEditBase";
import WorkerPoolEditBase from "./WorkerPoolEditBase";

type StaticWorkerPoolEditState = WorkerPoolEditState<StaticWorkerPoolResource>;

class StaticWorkerPoolEdit extends WorkerPoolEditBase<StaticWorkerPoolResource, StaticWorkerPoolEditState> {
    getDefaultState(): StaticWorkerPoolEditState {
        return {
            deleted: false,
            model: this.props.workerPool,
            cleanModel: cloneDeep(this.props.workerPool),
        };
    }

    customExpandableFormSections(): JSX.Element[] {
        return [];
    }
}

export default StaticWorkerPoolEdit;
